"use client";

import { useEffect, useState } from "react";

export function Video() {
  const [videoIframeSrc, setVideoIframeSrc] = useState<string>("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchVideoUrl = async () => {
      try {
        const response = await fetch("/api/config/video.php");
        const data = await response.json();
        setVideoIframeSrc(data.videoUrl);
      } catch (error) {
        console.error("Failed to load video URL:", error);
        // Fallback URL if fetch fails
        setVideoIframeSrc("https://www.facebook.com/plugins/video.php?height=315&href=https%3A%2F%2Fwww.facebook.com%2Freel%2F2690894291260753%2F&show_text=false&width=560&t=0");
      } finally {
        setLoading(false);
      }
    };
    fetchVideoUrl();
  }, []);

  return (
    <section className="py-16 sm:py-20 lg:py-24 px-4 bg-gradient-to-b from-background to-muted/30">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12 animate-in fade-in duration-700">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-6 text-balance">
            Experience the <span className="text-orange-500">Journey</span>
          </h2>
          <p className="text-lg sm:text-xl text-muted-foreground max-w-2xl mx-auto text-pretty leading-relaxed">
            Watch how we create unforgettable memories and transform ordinary
            trips into extraordinary adventures
          </p>
        </div>

        <div className="relative rounded-2xl overflow-hidden shadow-2xl animate-in slide-in-from-bottom duration-700 bg-black flex items-center justify-center" style={{ animationDelay: '200ms' }}>
          {loading ? (
            <div className="w-full aspect-video flex items-center justify-center">
              <div className="text-white">Loading video...</div>
            </div>
          ) : (
            <div className="relative w-full" style={{ paddingBottom: '56.25%', height: 0 }}>
              <iframe
                src={videoIframeSrc}
                title="Travel Warehouse Video"
                style={{
                  border: 'none',
                  overflow: 'hidden',
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%'
                }}
                scrolling="no"
                frameBorder="0"
                allowFullScreen={true}
                allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
              />
            </div>
          )}
        </div>

        {/* Video description */}
        <div className="mt-6 text-center">
          <h3 className="text-xl sm:text-2xl font-bold mb-2">Our Latest Travel Moments</h3>
          <p className="text-muted-foreground text-sm sm:text-base">
            Discover the incredible experiences our clients have with Travel Warehouse
          </p>
        </div>
      </div>
    </section>
  );
}
